import { render } from "./GlosarioModal.vue?vue&type=template&id=a9ff7a22"
import script from "./GlosarioModal.vue?vue&type=script&lang=js"
export * from "./GlosarioModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__